import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';

const PaymentsLayout: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const tabIndex = pathname.includes('/paypal')
    ? 1
    : pathname.includes('/check-batches')
      ? 2
      : 0;

  const handleTab = (_: React.SyntheticEvent, newValue: number) => {
    const routes = ['stripe', 'paypal', 'check-batches'];
    navigate(`/finance/payments/${routes[newValue]}`);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Payments
      </Typography>
      <Tabs value={tabIndex} onChange={handleTab} sx={{ mb: 2 }}>
        <Tab label="Stripe" />
        <Tab label="PayPal" />
        <Tab label="Check batches" />
      </Tabs>
      <Outlet />
    </Box>
  );
};

export default PaymentsLayout;
